/* eslint-disable jira/filename-case, jira/wrm/no-load-bridge */

import {
	wrmRequire,
	wrmRequireWithPrefetch,
	type BatchDetailsResponseType,
} from '@jira/platform__bridge/src';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const asyncWrmRequire = (resourcesToRequire: string[]): Promise<any> =>
	wrmRequire(resourcesToRequire);

export const asyncWrmRequireWithPrefetch = (
	resourcesToRequire: string[],
	batchUrl: BatchDetailsResponseType, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => wrmRequireWithPrefetch(resourcesToRequire, batchUrl);
